/**
 * <nwf-disclosure data-collapsed>
 *
 * Generic show-more / show-less toggle, used by the product highlights and the
 * quantity discount tiers in the buy box.
 *
 * The collapsed state and the hidden content are rendered server-side, so this
 * only flips the data-collapsed attribute, aria-expanded and the button label.
 * Everything visual is driven by CSS off data-collapsed, which keeps the first
 * paint correct - no layout shift, no flash of the expanded content.
 *
 * Expected markup:
 *   <nwf-disclosure data-collapsed
 *                   data-expand-label="…" data-collapse-label="…">
 *     …content, with the collapsible parts marked by the consumer's own CSS…
 *     <button data-nwf-disclosure-toggle aria-expanded="false">
 *       <span data-nwf-disclosure-label>…</span>
 *     </button>
 *   </nwf-disclosure>
 */
if (!customElements.get('nwf-disclosure')) {
    customElements.define(
        'nwf-disclosure',
        class NwfDisclosure extends HTMLElement {
            connectedCallback() {
                this.button = this.querySelector('[data-nwf-disclosure-toggle]');
                if (!this.button) return;

                this.label = this.querySelector('[data-nwf-disclosure-label]');
                this.onClick = this.toggle.bind(this);
                this.button.addEventListener('click', this.onClick);
            }

            disconnectedCallback() {
                this.button?.removeEventListener('click', this.onClick);
            }

            toggle() {
                const wasCollapsed = this.hasAttribute('data-collapsed');

                this.toggleAttribute('data-collapsed', !wasCollapsed);
                this.button.setAttribute('aria-expanded', String(wasCollapsed));

                if (this.label) {
                    this.label.textContent = wasCollapsed ? this.dataset.collapseLabel : this.dataset.expandLabel;
                }
            }
        },
    );
}
